
import React from 'react';
import { TimePicker } from "@mui/x-date-pickers";
import { useTranslation } from 'react-i18next';

  
export default function TimePickerCustom(props) {
    const { t } = useTranslation();

      return (
        <TimePicker
          {...props}
          localeText={{toolbarTitle:t('select_time')}}
        />
      );
    };